import React from 'react';

import { Button } from '../../components';
import { getEnvironmentName } from '../../utils/window';

const RadarDashboardButton = ({ disabled = false, tripId, t }) => {
  return (
    <Button
      disabled={disabled}
      onClick={() => {
        const isProd = getEnvironmentName() === 'prod';

        if (tripId) {
          window.open(
            `https://dashboard.radar.com/geofencing/trips/${tripId}?project=6423e3b2461869001fabead6&live=${isProd}`,
            '_blank',
          );
        }
      }}
    >
      {t('openRadarDashboard')}
    </Button>
  );
};

export default RadarDashboardButton;
